import { FdrProductTravelType } from '@hotelplan/supergraph-api';
import {
  TFdrProductTypeData,
  TFdrProductType,
} from 'fdr/components/local/fdr-product-card/fdr-product-card.types';
import { fdrProductClassDictionary } from './fdr-travel-type.constants';

export const getFdrProductIcons = (
  productTravelType: FdrProductTravelType,
  productType: TFdrProductType | null | undefined
): TFdrProductTypeData[] | null => {
  if (!productType) return null;
  const productClassIcon = fdrProductClassDictionary[productType];
  if (productTravelType === FdrProductTravelType.HotelOnly) {
    return [productClassIcon];
  }
  return [
    {
      icon: 'flug',
      title: 'common:flight',
    },
    productClassIcon,
  ];
};
